import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81dbac78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索主题")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索详情")
const _hoisted_15 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_16 = { class: "card-body table-responsive p-0" }
const _hoisted_17 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_18 = { ref: "tableTr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "序号", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workStatusName" }, "状态", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workCode" }, "编号", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "processDuration" }, "整体时长", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "activityName" }, "最近节点", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "taskDuration" }, "节点时长", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "fromOrgCode" }, "组织代码", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workSubject" }, "工单主题", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workStar" }, "工单星级", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "workSchedule",
  class: "normal-width text-left"
}, "完成进度", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "ownerMainName" }, "运维", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "ownerInfoName" }, "信息", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "ownerIntegratedName" }, "集成", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "发起时间", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "lastReplyTime" }, "最后回复", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "completeTime" }, "完成时间", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["colspan"]
const _hoisted_38 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_39 = { class: "table-btn-group" }
const _hoisted_40 = { class: "btn-group" }
const _hoisted_41 = { class: "project_progress p-2-1" }
const _hoisted_42 = { class: "progress progress-sm mt-1" }
const _hoisted_43 = { class: "float-left" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_48 = { class: "content-modal" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("(一句话描述)")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("(详细描述，可留空，后面再补)")

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_button_tooltip = _resolveComponent("app-button-tooltip")
  const _component_app_star = _resolveComponent("app-star")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_work_view = _resolveComponent("app-work-view")
  const _component_app_work_schedule = _resolveComponent("app-work-schedule")
  const _component_ProcessWorkspace = _resolveComponent("ProcessWorkspace")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_select_star = _resolveComponent("app-select-star")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_textarea = _resolveComponent("app-textarea")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/aftersale/ticket/works/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, "发起工单"))
                : _createCommentVNode("", true),
              (_ctx.Auth('/aftersale/ticket/works/add1'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openWorkViewModal && _ctx.openWorkViewModal(...args)))
                  }, "发起聊天"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/aftersale/ticket/works/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/aftersale/ticket/works/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      (_ctx.tableRequestItem.lockItem)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableRequestItem.lockItem, (item, key, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i===0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                class: _normalizeClass([item.value?'hyper-text-themes':'', "dropdown-item hand"]),
                                onClick: item.openFn
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: item.value?'radio-button-on':'radio-button-off',
                                  class: "mt-0 mr-1"
                                }, null, 8, ["name"]),
                                _createTextVNode(" " + _toDisplayString(item.title), 1)
                              ], 10, _hoisted_11)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('t.work_subject')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_13
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.searchFunction('t.work_describe')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_14
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[8] || (_cache[8] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.Auth('/aftersale/ticket/works/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_18, [
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("th", {
                        field: "fromOrgName",
                        class: "table-search-lock hand active",
                        onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "所属组织"),
                      _createElementVNode("th", {
                        field: "fromOrgTypeIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.orgTypeIdLevelModalOpen && _ctx.orgTypeIdLevelModalOpen(...args)))
                      }, "组织类型"),
                      _createElementVNode("th", {
                        field: "sendRealName",
                        class: "table-search-lock hand active",
                        onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.userCodeLevelModalOpen && _ctx.userCodeLevelModalOpen(...args)))
                      }, "发起人"),
                      _createElementVNode("th", {
                        field: "projectIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.projectIdLevelModalOpen && _ctx.projectIdLevelModalOpen(...args)))
                      }, "所属设备"),
                      _createElementVNode("th", {
                        field: "businessIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.businessIdLevelModalOpen && _ctx.businessIdLevelModalOpen(...args)))
                      }, "故障类型"),
                      _createElementVNode("th", {
                        field: "influenceIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.influenceIdLevelModalOpen && _ctx.influenceIdLevelModalOpen(...args)))
                      }, "影响范围"),
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_38
                          ], 8, _hoisted_37)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.workId,
                        class: _normalizeClass({'text-red': parseInt(item.starStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            (_ctx.Auth('/aftersale/ticket/works/processFlow'))
                              ? (_openBlock(), _createBlock(_component_app_button_tooltip, {
                                  key: 0,
                                  content: "流程处理",
                                  onBtnClick: $event => (_ctx.flowProcessing(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { name: "process-fill" })
                                  ]),
                                  _: 2
                                }, 1032, ["onBtnClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.$tools.isEmpty(item.completeName)?'badge-danger':'badge-light'])
                          }, _toDisplayString(item.workStatusName), 3)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.workCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.processDuration), 1),
                        _createElementVNode("td", null, _toDisplayString(item.activityName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.taskDuration), 1),
                        _createElementVNode("td", null, _toDisplayString(item.fromOrgCode), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString(item.fromOrgName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.fromOrgTypeIdName), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.userCode.value? 'active' : ''])
                        }, _toDisplayString(item.sendRealName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectId.value? 'active' : ''])
                        }, _toDisplayString(item.projectIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.businessId.value? 'active' : ''])
                        }, _toDisplayString(item.businessIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.influenceId.value? 'active' : ''])
                        }, _toDisplayString(item.influenceIdName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.workSubject), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_app_star, {
                            val: item.workStar
                          }, null, 8, ["val"])
                        ]),
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", {
                              class: "progress-bar bg-green",
                              style: _normalizeStyle({width: item.workSchedule + '%'})
                            }, null, 4)
                          ]),
                          _createElementVNode("small", _hoisted_43, _toDisplayString(item.workSchedule + '%') + " 已完成 ", 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.ownerMainName || '无'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.ownerInfoName || '无'), 1),
                        _createElementVNode("td", null, _toDisplayString(item.ownerIntegratedName || '无'), 1),
                        _createElementVNode("td", {
                          class: "p-0",
                          innerHTML: item.createTime.replace(' ', '<\/br>')
                        }, null, 8, _hoisted_44),
                        _createElementVNode("td", {
                          class: "p-0",
                          innerHTML: item.lastReplyTime.replace(' ', '<\/br>')
                        }, null, 8, _hoisted_45),
                        _createElementVNode("td", {
                          class: "p-0",
                          innerHTML: item.completeTime.replace(' ', '<\/br>')
                        }, null, 8, _hoisted_46)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_48, [
      _createVNode(_component_app_select_level, {
        ref: "userCodeLevel",
        levelType: "onLest",
        levelApi: _ctx.getUserApi,
        selectItem: _ctx.tableRequestItem.lockItem.userCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.userCodeLevelFunction,
        searchFieldList: _ctx.userCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "orgCodeLevel",
        levelType: "select",
        levelApi: _ctx.getOrgApi,
        selectItem: _ctx.tableRequestItem.lockItem.orgCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.orgCodeLevelFunction,
        searchFieldList: _ctx.orgCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "projectIdLevel",
        levelType: "onLest",
        levelApi: _ctx.getProjectApi,
        selectItem: _ctx.tableRequestItem.lockItem.projectId,
        selectFunction: _ctx.projectIdLevelFunction,
        searchFieldList: _ctx.projectIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "orgTypeIdLevel",
        levelType: "select",
        levelApi: _ctx.getOrgTypeAPI,
        selectItem: _ctx.tableRequestItem.lockItem.orgTypeId,
        maxParentId: null,
        selectFunction: _ctx.orgTypeIdLevelFunction,
        searchFieldList: _ctx.orgTypeIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "influenceIdLevel",
        levelType: "select",
        levelApi: _ctx.getInfluenceApi,
        selectItem: _ctx.tableRequestItem.lockItem.influenceId,
        selectFunction: _ctx.influenceIdLevelFunction,
        searchFieldList: _ctx.influenceIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "businessIdLevel",
        levelType: "select",
        levelApi: _ctx.getBusinessApi,
        selectItem: _ctx.tableRequestItem.lockItem.businessId,
        selectFunction: _ctx.businessIdLevelFunction,
        searchFieldList: _ctx.businessIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_work_view, {
        ref: "workViewModal",
        workStyle: "works",
        modelValue: _ctx.editModalItem,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.editModalItem) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_app_work_schedule, {
        ref: "workScheduleModal",
        modelValue: _ctx.editModalItem,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.editModalItem) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ProcessWorkspace, {
        ref: "processView",
        onFlowSubmit: _ctx.onFlowSubmit
      }, null, 8, ["onFlowSubmit"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: "发起工单",
        submitButtonName: "提交",
        size: "lg",
        submitFunction: _ctx.editModalSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-12",
              label: "所属项目",
              modelValue: _ctx.editModalItem.projectId,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.editModalItem.projectId) = $event)),
              searchApi: _ctx.projectIdSelectApi
            }, null, 8, ["modelValue", "searchApi"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-4",
              label: "故障类型",
              modelValue: _ctx.editModalItem.businessId,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.editModalItem.businessId) = $event)),
              searchApi: _ctx.businessIdSelectApi,
              "onUpdate:changeValue": _ctx.uploadWorkStar
            }, null, 8, ["modelValue", "searchApi", "onUpdate:changeValue"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-4",
              label: "影响范围",
              modelValue: _ctx.editModalItem.influenceId,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.editModalItem.influenceId) = $event)),
              searchApi: _ctx.influenceIdSelectApi,
              "onUpdate:changeValue": _ctx.uploadWorkStar
            }, null, 8, ["modelValue", "searchApi", "onUpdate:changeValue"]),
            _createVNode(_component_app_select_star, {
              class: "col-lg-4",
              label: "工单星级",
              modelValue: _ctx.editModalItem.workStar,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.editModalItem.workStar) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("(" + _toDisplayString(_ctx.editModalItem.workStar) + "星)", 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-12",
              modelValue: _ctx.editModalItem.workSubject,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.editModalItem.workSubject) = $event)),
              label: "工单主题"
            }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_textarea, {
              class: "col-lg-12",
              modelValue: _ctx.editModalItem.workDescribeLaunch,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.editModalItem.workDescribeLaunch) = $event)),
              label: "工单描述"
            }, {
              default: _withCtx(() => [
                _hoisted_51
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["submitFunction"])
    ])
  ]))
}